<template>
  <div>
    <div class="card my-1">
      <div class="card-content">
        <div class="card-body">
          <h3>{{ title }}</h3>
          <div
            class="id-file"
            style="cursor: pointer"
            @click.prevent="openImageModal(imageSrc)"
          >
            <img class="id-file img-fluid" :src="imageSrc" alt="id file" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Magnifier",
  props: {
    imageSrc: {
      type: String
    },
    title: {
      type: String
    }
  },
  data() {
    return {
      images: []
    };
  },
  methods: {
    openImageModal(param) {
      this.images = [];
      this.$viewerApi({
        images: [param]
      });
      this.images.push(param);
      console.log(this.images);
      // this.photoLoading = true;
      console.log(param);
      setTimeout(() => this.setImage(param), 4000);
    },
    setImage(param) {
      this.imageModalQuery = param;
      // this.photoLoading = false;
      // this.showImageVisible = true;
    }
  }
};
</script>

<!-- <style lang="scss" scoped></style> -->
